import { User } from 'lucide-react'

import ArticleHero from '/react4xp/components/prototype/ArticleHero'

import type { ArticleProps } from './types'

export default function Article({ title, intro, tags = [], image, body, author }: ArticleProps) {
	return (
		<article className="mb-16">
			<ArticleHero title={title} intro={intro} tags={tags} image={image} />

			{body && (
				<div className="container mt-16">
					<div
						className="max-w-175 mx-auto rich-text"
						dangerouslySetInnerHTML={{ __html: body }}
						suppressHydrationWarning
					/>
				</div>
			)}

			{author && (
				<div className={`container ${body ? 'mt-12' : 'mt-16'}`}>
					<div className="max-w-175 mx-auto flex flex-col gap-6">
						<div className="h-px w-full bg-black-200" />
						<div className="flex items-center gap-4">
							{author.avatar ? (
								<figure className="w-14 h-14 max-w-full shrink-0 overflow-hidden rounded-full">
									<img src={author.avatar.src} alt={author.avatar.alt} className="w-full h-full object-cover" />
								</figure>
							) : (
								<figure className="w-14 h-14 max-w-full shrink-0 overflow-hidden rounded-full bg-brand-950 flex items-center justify-center">
									<User className="w-6 h-6 text-brand-300" aria-hidden="true" />
								</figure>
							)}
							<div className="flex flex-col">
								<p className="h5 text-black-950">{author.name}</p>
								{author.role && <p className="body-small text-black-600">{author.role}</p>}
							</div>
						</div>
					</div>
				</div>
			)}
		</article>
	)
}
